<template>
    <div class="main">
        <div
            class=""
            :class="{'p-0 justify-content-start align-items-center align-items-md-start border-none': show === 'img', 'dropzone-container-img' : show === 'img', 'dropzone-container-purple' : show === 'purple'}"
            @dragover="dragover"
            @dragleave="dragleave"
            @drop="drop"
        >
            <div class="dropzone-purple-content"
                v-if="show === 'purple'">
                <img src="/images/icons/file-plus.svg" alt="">
                <p class="mt-3">
                    <span>{{ lang === 'ar-sa' ? 'رفع الملف' : 'Upload a file'}}</span>
                    {{ lang === 'ar-sa' ? 'أو السحب هنا' : 'or drag and drop'}}</p>
                <p>{{ lang === 'ar-sa' ? 'OBJ, STL, FBX ,3MF حتى 100 ميجابايت' : 'OBJ, STL, FBX up to 100MB'}}</p>
            </div>
            <input
                type="file"
                name="file"
                id="fileInput"
                class="hidden-input"
                :class="{'purple-btn__file': (show === 'purple'), 'btn__file': (show === 'origin')}"
                @change="onChange($event)"
                ref="file"
                accept=".stl,.obj,.3mf,.fbx"
            />

            <label v-if="show === 'origin' " for="fileInput" class="file-label">
                <div v-if="isDragging">Release to drop files here.</div>
                <div v-else class="add-name" :class="{'show-name__file': (show === 'origin') }">Upload file</div>
                <img class="icon-uploaded-file position-absolute" src="/images/icons/upload.svg" alt="upload">
            </label>
            <label v-if="show === 'img' " for="fileInput" class="file-label">
<!--                <img alt="add_file" class="add-file" role="button" src="/images/icons/add.svg"-->
<!--                     v-if="modelForm.models.length">-->
                <a type="button" class="btn btn-purple">{{  lang === 'ar-sa' ? 'إضافة نموذج جديد' : 'Add New Model' }}</a>
            </label>
            <label v-if="show === 'purple'" for="file" @click="downloadFile"
                   class="opacity-0 zindex-4 mx-md-auto btn-purple-upload-file btn-purple btn position-absolute">{{ titlesUpload.upload }}</label>

        </div>
    </div>
</template>

<script>
export default {
    props: ['show', 'purpleFile', 'files1', 'dataToCreateClientModel', 'modelForm'],
    data() {
        return {
            isDragging: false,
            lang: window.currentLang,
            images: [],
            titlesUpload: {
                upload: ''
            }
        };
    },

    mounted() {
        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
    },
    methods: {
        downloadFile(){
            let vm = this
            vm.$refs.file.click();
        },
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                this.titlesUpload.upload = 'رفع الملفات'
            } else {
                this.lang = 'en'
                this.titlesUpload.upload = 'Upload 3D model'
            }
        },
        onChange(event) {
            let vm = this

            let files = vm.$refs.file.files

            for (let i = 0; i < files.length; i++) {

                let objFile = {
                    file: files.item(i),
                    price: '',
                    material: '',
                    color: '',
                    height: '',
                    percentage: '',
                    number: 1
                }
                vm.modelForm.models.push(objFile)
                vm.modelForm.step = 0;
            }

        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange(e);

            this.isDragging = false;
        },
        remove(i) {
            // let showNameFile = document.querySelector('.show-name__file')
            // let hideBtn = document.querySelector('.js-cteate-model-btn')
            // hideBtn.classList.add('d-none')
            // showNameFile.textContent = 'Uploaded File'
        },
        generateURL(file) {
            let fileSrc = null

            if (file.name && (!file.name.includes('.obj') && !file.name.includes('.stl') && !file.name.includes('.3mf'))) {
                fileSrc = URL.createObjectURL(file);
                setTimeout(() => {
                    URL.revokeObjectURL(fileSrc);
                }, 1000);
            } else {
                fileSrc = '/images/no-photo.png'
            }

            return fileSrc;
        },
    },
};
</script>
<style>

.dropzone-container-purple {
    position: relative;
    background: white;
    border: 4px dashed rgba(48, 20, 125, 0.50);
    height: 386px;
    min-height: 4.4rem;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;


}
.dropzone-container-purple:hover {
    background: rgba(48, 20, 125, 0.10);
    transition: background-color 0.3s ease-in-out;
    cursor: pointer;

}
.dropzone-container-purple:hover img {
    filter: brightness(0) invert(1) grayscale(100%);
}
.dropzone-purple-content {
    position: absolute;
    left: 50%;


    transform: translate(-50%, 0);
}
.dropzone-purple-content p {
    font-size: 20px !important;
}
.dropzone-purple-content p:last-child {
   opacity: 0.5;
}
.dropzone-purple-content span {
    color: #30147D;

    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}
.dropzone-purple-content img {
    object-fit: none !important;
    height: 130px !important;
    min-height: 0 !important;
    min-width: 0 !important;
}
.dropzone-container-img {
    height: max-content;
    min-height: 4.4rem;
    border: 0.1rem solid #CDCDCD;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    padding: 1rem 2rem;
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 0;
    /*width: auto;*/
    height: 0;
    cursor: pointer;
}

.file-label {

    font-size: 1.4rem;
    line-height: 2.4rem;
    cursor: pointer;
    color: rgba(62, 62, 62, 0.5);
    margin-bottom: 0;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
    flex-wrap: wrap;
}

.preview-card {
    width: max-content;
    display: flex;
    padding: 0.5rem;
    margin-left: 0.5rem;
    -webkit-transform: scale(1, 1);
    -webkit-transition-timing-function: ease-out;
    -webkit-transition-duration: 550ms;
    -moz-transform: scale(1, 1);
    -moz-transition-timing-function: ease-out;
    -moz-transition-duration: 550ms;
}

.preview-card:hover {
    box-shadow: 0 1.5rem 2.0rem rgba(204, 204, 204, 0.25);
    -webkit-transform: scale(1.02, 1.02);
    -webkit-transition-timing-function: ease-out;
    -webkit-transition-duration: 550ms;
    -moz-transform: scale(1.02, 1.02);
    -moz-transition-timing-function: ease-out;
    -moz-transition-duration: 550ms;
}

.preview-img {
    width: 15rem;
    height: 15rem;
    border-radius: 0.5rem;
}

.dropzone_info_file p {
    word-break: break-all;
    width: 15rem;
    padding: 0 !important;
    margin-top: 1rem;
}

button.btn__delete {
    width: 0.5rem;
    border: none;
    background-color: transparent;
}

.btn__delete i.fa-circle-xmark {
    right: -0.8rem;
    top: -1.3rem;
}

.border-none {
    border: none !important;
}

img.box-shadow-1, video.box-shadow-1 {
    box-shadow: 0 2px 5px 0 rgb(34 41 47 / 16%), 0 2px 10px 0 rgb(34 41 47 / 12%) !important;
}

</style>
